"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagFromLog = void 0;
const FlagFromLogMeta_1 = require("./FlagFromLogMeta");
function FlagFromLog(flag) {
    return (target, propertyKey) => {
        let meta = Reflect.getMetadata(FlagFromLogMeta_1.FLAG_FROM_LOG_META_SYM, target);
        meta = {
            ...meta,
            [propertyKey]: flag,
        };
        Reflect.defineMetadata(FlagFromLogMeta_1.FLAG_FROM_LOG_META_SYM, meta, target);
    };
}
exports.FlagFromLog = FlagFromLog;
//# sourceMappingURL=FlagFromLog.js.map